import { useEffect, useState } from "react";
import api from "../services/api.tsx";
import Order from "../Entities/Order";
import OrderStatus from "../Entities/Enums/OrderStatus.tsx";
import { useError } from "../contexts/ErrorContext.tsx";

const OrdersPage = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const { setError } = useError();

  useEffect(() => {
    const fetchOrders = async () => {
      const token = localStorage.getItem("access_token");
      try {
        const response = await api.get("/api/order", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOrders(response.data);
      } catch (error) {
        setError(error.response?.data?.Message || "Bir hata oluştu.");
      }
    };
    fetchOrders();
  }, [setError]);

  const getStatusBadge = (status: string) => {
    const statusText = OrderStatus[status as keyof typeof OrderStatus];
    const statusColors: Record<string, string> = {
      Pending: "bg-yellow-500",
      Confirmed: "bg-green-500",
      Cancelled: "bg-red-500",
      Abandoned: "bg-gray-500",
    };
    return (
      <span
        className={`px-2 py-1 text-black text-xs rounded ${statusColors[statusText] || "bg-gray-400"}`}>
        {statusText}
      </span>
    );
  };

  return (
    <div className="p-2 sm:p-4 md:p-8 max-w-4xl mx-auto">
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">Sipariş Geçmişim</h2>
      {orders.length === 0 ? (
        <p className="text-gray-600 text-center">Henüz sipariş vermediniz.</p>
      ) : (
        <div className="grid gap-4">
          {orders.map((order) => (
            <div
              key={order.id}
              className="bg-white rounded-xl shadow-md border border-gray-200 p-4 flex flex-col gap-2"
            >
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                  <span className="text-gray-500 text-xs">{new Date(order.createdAt).toLocaleString()}</span>
                  <span>{getStatusBadge(order.status)}</span>
                </div>
                <div className="flex flex-wrap gap-4 text-sm sm:text-base">
                  <span>
                    <span className="font-semibold text-gray-700">Ön Ödeme:</span>{" "}
                    <span className="text-blue-700 font-bold">{order.depositPaid} TL</span>
                  </span>
                  <span>
                    <span className="font-semibold text-gray-700">Toplam:</span>{" "}
                    <span className="text-green-700 font-bold">{order.totalAmount} TL</span>
                  </span>
                </div>
              </div>
              <details className="mt-2 group">
                <summary className="cursor-pointer text-blue-600 hover:underline font-medium text-sm flex items-center gap-2">
                  <span>Ürün Detayları</span>
                  <svg className="w-4 h-4 group-open:rotate-90 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" /></svg>
                </summary>
                <ul className="mt-3 space-y-3">
                  {order.orderItems.map((item, index) => (
                    <li key={index} className="border-b pb-2 last:border-b-0">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                        <div>
                          <span className="font-semibold">{item.product.name}</span>
                          <span className="ml-2 text-gray-500">× {item.quantity}</span>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                          {item.campaignId ? (
                            <>
                              <span className="text-gray-500 line-through">{item.unitPrice} TL</span>
                              <span className="text-green-700 font-bold">{item.finalPrice} TL</span>
                              <span className="ml-1 text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                                Kampanya: {item.campaign?.name}
                              </span>
                            </>
                          ) : (
                            <span className="font-bold">{item.unitPrice} TL</span>
                          )}
                          <span className="ml-2 text-gray-600 text-xs">
                            Toplam: <span className="font-semibold">{((item.finalPrice ?? item.unitPrice) * item.quantity).toLocaleString()} TL</span>
                          </span>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </details>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrdersPage;